class ProductUSPs extends HTMLElement {
  productId = this?.dataset?.productId;
  sectionId = this?.dataset?.sectionId;

  connectedCallback() {
    this.unsubscribeVariantChange = subscribe(`variant:changed:${this.productId}:${this.sectionId}`, ({ html }) => {
      // Kopstorm: a variant without USPs keeps the current list instead of throwing.
      const source = html?.querySelector('product-usps');
      if (!source) return;
      this.replaceWith(source.cloneNode(true));
    });
  }

  disconnectedCallback() {
    this.unsubscribeVariantChange?.();
  }
}

customElements.define('product-usps', ProductUSPs);
